import { SchedulesPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/schedules/Index'

export const UnitSchedules = () => <SchedulesPage />
